import React, { useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import { getVolunteer } from "../../store/actions/volunteers_action";
import Spinner from "../../components/layout/Spinner";
import { inputFields } from "../../shared/enums/volunteers_enum";
import SingleView from "../../components/common/SingleView";
const ViewVolunteer = ({
  getVolunteer,
  match,
  volunteer: { loading, volunteer },
}) => {
  useEffect(() => {
    getVolunteer(match.params.id);
  }, [match]);
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Volunteers"
          mainLinkTitle="Volunteers"
          mainLinkUrl="/volunteers"
          activeLink="View"
        />
        {!loading ? (
          volunteer && (
            <SingleView
              data={volunteer}
              inputFields={inputFields}
              label="Volunteer"
              link="volunteers"
              id={volunteer.id}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ volunteer: state.volunteer });

const mapDispatchToProps = { getVolunteer };

export default connect(mapStateToProps, mapDispatchToProps)(ViewVolunteer);
